import React, { useState } from 'react';

export default function Collapse () {
    const [isOpen1, setIsOpen1] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);
    const [isOpen3, setIsOpen3] = useState(false);

    const toggleOpen1 = () => setIsOpen1(!isOpen1);
    const toggleOpen2 = () => setIsOpen2(!isOpen2);
    const toggleOpen3 = () => setIsOpen3(!isOpen3);

    return (
        <>
            <div id="accordion-collapse" data-accordion="collapse" className="mx-10">
                <h2 id="accordion-collapse-heading-1">
                    <button type="button" onClick={toggleOpen1} className="bg-collapse flex items-center justify-between w-full p-5 font-medium rtl:text-right border border-b-0 rounded-t-xl gap-3" data-accordion-target="#accordion-collapse-body-1" aria-expanded={isOpen1} aria-controls="accordion-collapse-body-1">
                        <span>C'est quoi Suplib ?</span>
                        <svg data-accordion-icon className={`w-3 h-3 ${isOpen1 ? "rotate-90" : "rotate-180"} shrink-0`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5 5 1 1 5"/>
                        </svg>
                    </button>
                </h2>
                <div id="accordion-collapse-body-1" className={isOpen1 ? "" : "hidden"} aria-labelledby="accordion-collapse-heading-1">
                    <div className="p-5 border border-b-0 bg-collapse">
                        <p className="mb-2">
                            En effet, Suplib est une librairie en ligne qui vous permet de trouver des livres de tout genre.
                        </p>
                        <p>
                            Que ce soit à travers des romans captivants ou des histoires de science-fiction fascinantes,
                            les livres ont le pouvoir magique de nous transporter dans des mondes imaginaires.
                            Ils nous emmènent dans des voyages extraordinaires à travers l'imagination des écrivains,
                            où les rêves prennent vie et de nouveaux univers prennent forme.
                            La force envoûtante des livres réside dans leur capacité à nous plonger
                            dans des réalités inconnues et à ancrer en nous des émotions inoubliables.
                        </p>
                    </div>
                </div>

                <h2 id="accordion-collapse-heading-2">
                    <button type="button" onClick={toggleOpen2} className="bg-collapse flex items-center justify-between w-full p-5 font-medium rtl:text-right border border-b-0 gap-3" data-accordion-target="#accordion-collapse-body-2" aria-expanded={isOpen2} aria-controls="accordion-collapse-body-2">
                        <span>Comment utiliser le site ?</span>
                        <svg data-accordion-icon className={`w-3 h-3 ${isOpen2 ? "rotate-90" : "rotate-180"} shrink-0`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5 5 1 1 5"/>
                        </svg>
                    </button>
                </h2>
                <div id="accordion-collapse-body-2" className={isOpen2 ? "" : "hidden"} aria-labelledby="accordion-collapse-heading-2">
                    <div className="p-5 border border-b-0 bg-collapse">
                        <p className="mb-4">Notre site dispose de plusieurs page, vous pourrez retrouver sur le site :</p>
                        <ul className="list-disc ml-5">
                            <li className="mb-2">Une page d'accueil</li>
                            <li className="mb-2">Une page de recherche rapide</li>
                            <li className="mb-2">Une page de recherche avancée</li>
                            <li className="mb-2">Une page de détail d'un livre</li>
                            <li className="mb-2">Une page de contact</li>
                            <li className="mb-2">Une newsletter</li>
                            <li>Une page à propos</li>
                        </ul>
                    </div>
                </div>

                <h2 id="accordion-collapse-heading-3">
                    <button type="button" onClick={toggleOpen3} className="bg-collapse flex items-center justify-between w-full p-5 font-medium rtl:text-right border focus:ring-4 gap-3" data-accordion-target="#accordion-collapse-body-3" aria-expanded={isOpen3} aria-controls="accordion-collapse-body-3">
                        <span>Pourquoi Suplib ?</span>
                        <svg data-accordion-icon className={`w-3 h-3 ${isOpen3 ? "rotate-90" : "rotate-180"} shrink-0`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5 5 1 1 5"/>
                        </svg>
                    </button>
                </h2>
                <div id="accordion-collapse-body-3" className={isOpen3 ? "" : "hidden"} aria-labelledby="accordion-collapse-heading-3">
                    <div className="p-5 border border-t-0 bg-collapse">
                        <p className="mb-2">Le site est né d'un projet scolaire. </p>
                        <p>Via l'API OpenLibrary, le site récupère les livres indexés dans l'API afin de vous donner la possibilité de rechercher ou voir plus de détails sur un livre. Notre but est de vous faire passer la meilleure expérience dans une librairie en ligne.</p>
                    </div>
                </div>
            </div>
        </>
    )
}